import { Component, OnInit, Input } from '@angular/core';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss']
})
export class DownloadCsvComponent implements OnInit {
  @Input() dataTable: any;
  @Input() title: string;
  @Input() name: string;
  @Input() headers: any[];
  @Input() remove: any[];

  constructor() {}

  ngOnInit() {}

  download(): void {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: this.title,
      useBom: true,
      noDownload: false,
      headers: this.headers,
      nullToEmptyString: true
    };
    this.removeFieldProperty(this.dataTable).then(
      csv => new Angular5Csv(csv, this.name + '_' + new Date(), options)
    );
  }

  // ANCHOR Remove propriedade indesejadas num objeto passado
  removeFieldProperty(data): Promise<any> {
    return new Promise(resolve => {
      const aux = data.map(res => {
        this.remove.map(item => delete res[item]);
        return res;
      });
      resolve(aux);
    });
  }
}
